<template>
  <div
    style="
      display: flex;
      gap: 20px;
      background-color: white;
      margin-top: 10px;
      border-radius: 10px;
      padding: 7px;
    "
  >
    <div
      @click="EventButtons(1)"
      :class="[activeName != 1 ? 'tab-gantt-task' : 'tab-gantt-task-active']"
    >
      Todas {{ activeName == 1 ? "(" + totalTask + ")" : "" }}
    </div>
    /
    <div
      @click="EventButtons(2)"
      :class="[activeName != 2 ? 'tab-gantt-task' : 'tab-gantt-task-active']"
    >
      Retrasadas
      {{ activeName == 2 ? "(" + totalTask + ")" : "" }}
    </div>
    /
    <div
      @click="EventButtons(3)"
      :class="[activeName != 3 ? 'tab-gantt-task' : 'tab-gantt-task-active']"
    >
      Semana Actual
      {{ activeName == 3 ? "(" + totalTask + ")" : "" }}
    </div>
    /
    <div
      @click="EventButtons(4)"
      :class="[activeName != 4 ? 'tab-gantt-task' : 'tab-gantt-task-active']"
    >
      Próxima Semana
      {{ activeName == 4 ? "(" + totalTask + ")" : "" }}
    </div>
    /
    <div
      @click="EventButtons(5)"
      :class="[activeName != 5 ? 'tab-gantt-task' : 'tab-gantt-task-active']"
    >
      Del Mes {{ activeName == 5 ? "(" + totalTask + ")" : "" }}
    </div>
    /
    <div
      @click="EventButtons(6)"
      :class="[activeName != 6 ? 'tab-gantt-task' : 'tab-gantt-task-active']"
    >
      Próximo mes
      {{ activeName == 6 ? "(" + totalTask + ")" : "" }}
    </div>
  </div>
</template>

<script>
export default {
  name: "TabGanttTask",
  props: {
    activeName: {
      type: Number,
      default: 1
    },
    totalTask: {
      type: Number,
      default: 1
    }
  },
  methods: {
    EventButtons(type) {
      this.$emit("getTasks", type);
    }
  }
};
</script>

<style scoped>
.tab-gantt-task {
  padding: 5px;
  cursor: pointer;
  height: auto;
  width: auto;
  border-radius: 10px;
  background-color: white;
}
.tab-gantt-task-active {
  padding: 5px;
  cursor: pointer;
  height: auto;
  width: auto;
  border-radius: 10px;
  background-color: rgba(158, 151, 151, 0.2);
  color: black;
}

.tab-gantt-task:hover {
  background-color: rgb(201, 199, 199);
  color: white;
}
</style>
